import { h } from 'preact'
import PropTypes from 'prop-types'
import PayPal from '../PayPal'

const PayPalCredit = ({ children, handleSubmit, showPaymentConfirmation }) => (
  <PayPal
    isCredit
    handleSubmit={handleSubmit}
    showPaymentConfirmation={showPaymentConfirmation}
  >
    {children}
  </PayPal>
)

PayPalCredit.propTypes = {
  children: PropTypes.element,
  handleSubmit: PropTypes.func,
  showPaymentConfirmation: PropTypes.bool,
}

export default PayPalCredit
